
import Vue from "vue";

export default Vue.extend({
  name: "ItemSummary",
  props: { item: { required: true, type: Object } },
  computed: {
    summary() {
      let name = "";
      if (this.item.ItemQuantity && this.item.ItemQuantity > 1)
        name = `${this.item.ItemName} (x${this.item.ItemQuantity})`;
      else name = this.item.ItemName;
      return name;
    },
    styles() {
      if (!this.item.Permitted) return { color: "orange" };
      if (this.item.Packed) return { color: "#00b2ff" };
      return {};
    },
  },
});
